export default __webpack_public_path__ + "static/hfncare-banner-97e09b47e7b7a62009bef84d56387df0.png";